// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"44bd626c","298":"10c87f0d","551":"403e0ce6"}[chunkId] + ".chunk.js";
};